module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_b/logo-aoj-en-9bb8ab04eff83c2026643632f74a0c35.svg";